import { CreateSnapshotModal } from "./CreateSnapshotModal";

export default CreateSnapshotModal;
